import { Card, CardContent } from '@/components/ui/card';
import { LucideIcon } from 'lucide-react';

interface Feature {
  icon: LucideIcon;
  title: string;
  description: string;
  iconClassName?: string;
}

interface OnboardingFeatureCardsProps {
  features: Feature[];
}

export function OnboardingFeatureCards({ features }: OnboardingFeatureCardsProps) {
  const gridCols = features.length <= 2
    ? 'grid-cols-1 sm:grid-cols-2'
    : 'grid-cols-1 sm:grid-cols-3';

  return (
    <div className={`grid ${gridCols} gap-3`}>
      {features.map((feature, i) => {
        const Icon = feature.icon;
        return (
          <Card key={i} className="border-border/50 bg-card">
            <CardContent className="p-4 space-y-2">
              <div className={`p-2 rounded-lg bg-primary/10 w-fit ${feature.iconClassName || ''}`}>
                <Icon className="h-4 w-4 text-primary" />
              </div>
              <h4 className="font-semibold text-sm text-foreground">{feature.title}</h4>
              <p className="text-xs text-muted-foreground leading-relaxed">{feature.description}</p>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}
